import {
    ESharedFunction,
    ESharedFunctionMultiple,
} from "motw_core/Enums/ESharedFunction";
import { State } from "./State";

export function ReadState<TState>(name: ESharedFunction) {
    const sharedFuncState = State.ReadFunction<TState>(name);

    if (sharedFuncState) {
        return sharedFuncState.state;
    }
}

export function ReadStateOrDefault<S>(name: ESharedFunction, defaultState: S) {
    const state = ReadState<S>(name);
    const result = state !== undefined ? state : defaultState;
    return result;
}

export function ReadStateMultiple<TState>(
    name: ESharedFunctionMultiple,
    uniqueKey: string
) {
    const sharedFuncState = State.ReadFunctionMultiple<TState>(name, uniqueKey);

    if (sharedFuncState) {
        return sharedFuncState.state;
    }
}
